<template lang="pug">
.award-container(v-if="show", @touchmove.prevent)
  .top-block
    img(v-if="!signShowStyle" src='https://m.hellobike.com/resource/helloyun/08345/Y8LC-AnF3o.png')
    img(v-else src='https://m.hellobike.com/resource/helloyun/22871/2qwekXyHF6.png')
    .close-btn(@click="close") 我知道了
  .shadow(@click="close")
</template>
<script>
import Lottie from '@/components/lottie';

export default {
  components: {
    Lottie,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    signShowStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.award-container {
  .top-block {
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 330;
    margin: 0 0.16rem;

    img {
      width: 100%;
    }

    .close-btn {
      margin: 0.21rem 0 0 2.02rem;
      text-align: center;
      width: 1rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      border: 0.01rem solid #979797;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fff;
      line-height: 0.4rem;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.81);
    z-index: 300;
  }
}
</style>
